<template>
  <div>
    <div class="home-btn d-none d-sm-block">
      <router-link tag="a" to="/login" class="text-dark">
        <i class="fas fa-home h2"></i>
      </router-link>
    </div>
    <div class="account-pages my-5 pt-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-12">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-4">
                      <h5 class="text-primary">Register</h5>
                      <p>Get your account now.</p>
                    </div>
                  </div>
                  <div class="col-5 align-self-end">
                    <img
                      src="@/assets/images/profile-img.png"
                      alt
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
              <div class="card-body">
                <h4 class="card-title">Register Wizard</h4>
                <form-wizard color="#556ee6" ref="wizard">
                  <tab-content icon="mdi mdi-account-circle">
                    <div class="row justify-content-center">
                      <div class="col-12">
                        <div class="mt-4 text-center">
                          <h5 class="font-size-14 mb-3">Signup with</h5>

                          <ul class="list-inline">
                            <li class="list-inline-item">
                              <a
                                id="btn_ofm_authen"
                                @click="onOauthSigninClick"
                                href="javascript: void(0);"
                                class="social-list-item bg-primary text-white border-primary"
                                data-scopes="default,email,employee"
                              >
                                OFM
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="mt-5 text-center">
                        <p>
                          Already have an account ?
                          <router-link
                            tag="a"
                            to="/login"
                            class="font-weight-medium text-primary"
                            >Login</router-link
                          >
                        </p>
                      </div>
                    </div>
                  </tab-content>
                  <tab-content icon="mdi mdi-face-profile">
                    <div class="row">
                      <div class="col-12">
                        <validationObserver ref="registerForm">
                          <div class="row">
                            <div class="col-sm-4">
                              <img
                                src="@/assets/images/register.jpg"
                                width="240"
                                height="240"
                              />
                            </div>
                            <div class="col-sm-6">
                              <div class="row">
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="name_en">ชื่อ (ไทย)</label>
                                    <validationProvider
                                      v-slot="{ errors }"
                                      name="Name Th"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <input
                                        id="name_th"
                                        name="name_th"
                                        type="text"
                                        class="form-control"
                                        placeholder="ระบุชื่อ (ภาษาไทย)"
                                        v-model="input.first_name.th"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                          'is-valid':
                                            !(errors && errors.length) &&
                                            input.first_name.th,
                                        }"
                                      />
                                      <div
                                        v-if="errors.length"
                                        class="validate-invalid"
                                      >
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </validationProvider>
                                  </div>
                                </div>
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="Surname">นามสกุล (ไทย)</label>
                                    <validationProvider
                                      v-slot="{ errors }"
                                      name="lastNameTh"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <input
                                        id="lastNameTh"
                                        name="lastNameTh"
                                        type="text"
                                        class="form-control"
                                        placeholder="ระบุนามสกุล (ภาษาไทย)"
                                        v-model="input.last_name.th"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                          'is-valid':
                                            !(errors && errors.length) &&
                                            input.last_name.th,
                                        }"
                                      />
                                      <div
                                        v-if="errors.length"
                                        class="validate-invalid"
                                      >
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="name_en">ชื่อ (อังกฤษ)</label>
                                    <validationProvider
                                      v-slot="{ errors }"
                                      name="Name En"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <input
                                        id="name_en"
                                        name="name_en"
                                        type="text"
                                        class="form-control"
                                        placeholder="ระบุชื่อ (ภาษาอังกฤษ)"
                                        v-model="input.first_name.en"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                          'is-valid':
                                            !(errors && errors.length) &&
                                            input.first_name.en,
                                        }"
                                      />
                                      <div
                                        v-if="errors.length"
                                        class="validate-invalid"
                                      >
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </validationProvider>
                                  </div>
                                </div>
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="Surname"
                                      >นามสกุล (อังกฤษ)</label
                                    >
                                    <validationProvider
                                      v-slot="{ errors }"
                                      name="lastNameEn"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <input
                                        id="lastNameEn"
                                        name="lastNameEn"
                                        type="text"
                                        class="form-control"
                                        placeholder="ระบุนามสกุล (ภาษาอังกฤษ)"
                                        v-model="input.last_name.en"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                          'is-valid':
                                            !(errors && errors.length) &&
                                            input.last_name.en,
                                        }"
                                      />
                                      <div
                                        v-if="errors.length"
                                        class="validate-invalid"
                                      >
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-12">
                                  <div class="form-group">
                                    <label for="Email">อีเมล</label>
                                    <input
                                      readonly
                                      id="email"
                                      name="email"
                                      type="text"
                                      class="form-control"
                                      style="background-color: #eee;"
                                      v-model="input.email"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="">เบอร์โทรศัพท์</label>

                                    <input
                                      id="phone_value"
                                      name="phone_value"
                                      type="text"
                                      class="form-control"
                                      placeholder="ระบุเบอร์โทรศัพท์"
                                      v-model="input.phone.value"
                                    />
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div class="form-group">
                                    <label for="Phone_Extention"
                                      >ต่อ (หมายเลข)</label
                                    >
                                    <input
                                      id="phone_extention"
                                      name="phone_extention"
                                      type="text"
                                      class="form-control"
                                      v-model="input.phone.extention"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-6">
                                  <div class="form-group">
                                    <label for="Mobile"
                                      >เบอร์โทรศัพท์มือถือ</label
                                    >
                                    <validationProvider
                                      v-slot="{ errors }"
                                      name="mobile"
                                      :rules="{
                                        dynamicRequired: ['กรุณาระบุข้อมูล'],
                                      }"
                                    >
                                      <input
                                        id="mobile"
                                        name="mobile"
                                        type="text"
                                        class="form-control"
                                        placeholder="ระบุเบอร์โทรศัพท์มือถือ"
                                        v-model="input.mobile"
                                        :class="{
                                          'is-invalid': errors && errors.length,
                                          'is-valid':
                                            !(errors && errors.length) &&
                                            input.mobile,
                                        }"
                                      />
                                      <div
                                        v-if="errors.length"
                                        class="validate-invalid"
                                      >
                                        <span>{{ errors[0] }}</span>
                                      </div>
                                    </validationProvider>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-sm-6">
                                  <div
                                    class="form-group"
                                    style="font-size: 15px;"
                                  >
                                    <label>รหัสผู้ขาย</label>
                                    <div>
                                      <vue-tags-input
                                        v-model="vendor_id"
                                        :tags="input.vendors_id"
                                        placeholder="ระบุรหัสผู้ขาย และ Enter"
                                        @tags-changed="
                                          newTags =>
                                            (input.vendors_id = newTags)
                                        "
                                      />
                                    </div>
                                    <div
                                      v-if="isValidate.vendors_id"
                                      class="validate-invalid"
                                    >
                                      <span>ไม่พบข้อมูล Vendor ID</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="text-right">
                                <button
                                  class="btn btn-primary mr-1"
                                  @click="onSubmit"
                                >
                                  Register
                                </button>
                                <button
                                  class="btn btn-secondary"
                                  @click="onReset"
                                >
                                  Reset
                                </button>
                              </div>
                            </div>
                          </div>
                        </validationObserver>

                        <!-- end card-->
                      </div>
                    </div>
                    <!-- end row -->
                  </tab-content>
                  <template slot="footer" slot-scope="props">
                    <div class="wizard-footer-left">
                      <b-button
                        variant="warning"
                        v-if="props.activeTabIndex > 0 && !props.isLastStep"
                        @click="props.prevTab()"
                      >
                        <i class="bx bx-left-arrow"></i> Previous
                      </b-button>
                    </div>
                    <div class="wizard-footer-right">
                      <b-button
                        variant="primary"
                        v-if="props.activeTabIndex > 1 && !props.isLastStep"
                        @click="props.nextTab()"
                      >
                        <i class="bx bx-right-arrow"></i> Next
                      </b-button>
                    </div>
                  </template>
                </form-wizard>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Vue from 'vue'
import { FormWizard, TabContent } from 'vue-form-wizard'
import profileProvider from '@/helpers/service/profile-provider'
import appConfig from '@/app.config'
import VueTagsInput from '@johmun/vue-tags-input'
import adminuserService from '@/helpers/service/adminuser-service'
import userService from '@/helpers/service/user-provider'
import groupService from '@/helpers/service/group-provider'
import { eventBus } from '@/main.js'

export default {
  components: { FormWizard, TabContent, VueTagsInput },
  data() {
    return {
      authError: null,
      isAuthStateLoading: true,
      isAuthError: false,
      oauthConfig: {
        clientId: process.env.VUE_APP_OAUTH_CLIENT_ID,
        clientSecret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
        grantType: 'authorization_code',
        redirect_url: `${process.env.VUE_APP_BASE_URL}/register`,
      },

      titlePage: 'Register',
      items: [
        {
          text: 'Account',
          href: '/',
        },
        {
          text: 'Register',
          active: true,
        },
      ],
      title: ['คุณ', 'นาย', 'นาง', 'นางสาว'],
      input: {
        title: '',
        first_name: {
          th: '',
          en: '',
        },
        last_name: {
          th: '',
          en: '',
        },
        default_language: '<TH><EN>',
        email: '',
        user_open_id: '',
        photo: '',
        token: '',
        mobile: '',
        phone: {
          value: '',
          extention: '',
        },
        vendors_id: [],
        create_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
        update_info: {
          timestamp: '',
          user_id: '',
          user_name: '',
        },
      },
      vendor_id: '',
      isValidate: {
        vendors_id: false,
      },
      applicationId: '',
      is_invite: false,
      invite_code: '',
      group_invite: {},
      group_invite_data: {},
    }
  },
  async mounted() {
    this.applicationId = process.env.VUE_APP_GET_APPLICATION_SELECTED
    if (this.$route.query.invite_code) {
      console.log('test', this.$route.query.invite_code)
      this.is_invite = true
      this.invite_code = this.$route.query.invite_code
      this.oauthConfig.redirect_url = `${this.oauthConfig.redirect_url}?invite_code=${this.invite_code}`
    }

    if (
      this.$route.query.authorize_code &&
      this.$route.query.access_token_url &&
      this.$route.query.secret_key
    ) {
      this.$cookies.set('.oauth.sk', this.$route.query.secret_key)
      var accessToken = await this.getAccessToken(
        this.$route.query.authorize_code,
        this.$route.query.access_token_url
      )
    }
  },
  watch: {
    'input.vendors_id': {
      handler: function(val) {
        if (this.input.vendors_id.length > 0) {
          // if (this.input.vendors_id.slice(-1).pop().text === "777") {
          //   this.input.vendors_id.splice(-1, 1);
          //   this.isValidate.vendors_id = true;
          // } else {
          //   this.isValidate.vendors_id = false;
          // }
          this.onValidateVendorIds()
        }
      },
      deep: true,
    },
  },
  methods: {
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    onSubmit() {
      if (this.isValidate.vendors_id && !this.input.vendors_id.length) {
        this.isValidate.vendors_id = false
      }

      this.$refs.registerForm.validate().then(result => {
        console.log('result', result)
        if (result && !this.isValidate.vendors_id) {
          this.createAdminUser()
        }
      })
    },
    onReset() {
      Object.keys(this.input).forEach(fieldName => {
        if (fieldName === 'vendors_id') {
          this.input[fieldName] = []
        } else if (fieldName !== 'email') {
          this.input[fieldName] = ''
        }
      })
      this.$nextTick(() => this.$refs.registerForm.reset())
    },
    async createAdminUser() {
      let result = await adminuserService.createAdminUserAsync(this.input)
      if (result.status === 201) {
        if (this.is_invite) await this.onCreateInviteGroupUserByCode()
        else {
          this.$utils.notification('success', 'Register Successed', 1500)
          this.onReset()
          this.$router.push({ path: '/login' })
        }
      } else if (
        (result.status && result.status !== 500) ||
        (result.response && result.response.status !== 500)
      ) {
        this.$utils.notification('error', result.response.data.message, 2000)
      }
    },
    isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep
      }
      return false
    },
    onOauthSigninClick() {
      var sk = this.$cookies.get('.oauth.sk')
      if (sk) {
        let queryString = sk
      }
      let scopes = 'default,email,employee'
      let redirect_url = encodeURIComponent(this.oauthConfig.redirect_url)
      console.log('redirect_url', redirect_url)
      let oauthlocation = `${process.env.VUE_APP_BASE_URL_OAuth}authentication/signin?client_id=${this.oauthConfig.clientId}&redirect_uri=${redirect_url}&scopes=${scopes}`
      console.log('oauthlocation', oauthlocation)
      window.location.href = oauthlocation
    },
    getVendorData(value) {
      console.log(value)
    },
    async getAccessToken(authorize_code, access_token_url) {
      const data = JSON.stringify({
        client_id: this.oauthConfig.clientId,
        client_secret: this.oauthConfig.clientSecret,
        grant_type: this.oauthConfig.grantType,
        authorize_code: authorize_code,
      })

      await axios({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'Post',
        data: data,
        url: `${access_token_url}`,
      }).then(
        async result => {
          if (result.data.refresh_token && result.data.access_token) {
            this.$cookies.set('.oauth.rt', result.data.refresh_token, 365)
            this.$cookies.set('.oauth.at', result.data.access_token, 365)
            if (result.data.info && result.data.info != null) {
              let info = JSON.stringify({
                name: result.data.info.name,
                email: result.data.info.email,
                photo: result.data.info.photo,
                person_locale: result.data.info.person_locale,
              })
              this.$cookies.set('.oauth.usr', info, 365)
            }
            console.log('result.data', result.data)
            await this.getUserInfo(result.data.access_token)
          }
        },
        error => {
          console.log(error.response)
        }
      )
    },
    async getUserInfo(accessToken) {
      console.log('accessTokenssss', accessToken)
      await axios({
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'Get',
        url: `${process.env.VUE_APP_BASE_URL_GRAPH}api/v1/me?access_token=${accessToken}`,
      }).then(
        async result => {
          console.log('result VUE_APP_BASE_URL_GRAPH', result)
          this.input.email = result.data.email
          this.input.first_name.en = result.data.name.en
          this.input.last_name.en = result.data.last_name.en
          this.input.token = accessToken
          this.input.user_open_id = result.data.open_id
          console.log('is next step', this.is_invite)
          if (this.is_invite) {
            console.log('next step', this.is_invite)
            this.group_invite_data = result.data
            await this.getGroupInviteCode()
          } else if (this.$refs.wizard) {
            this.$refs.wizard.nextTab()
          }
        },
        error => {
          console.log(error.response)
        }
      )
    },
    async onValidateVendorIds() {
      if (this.input.vendors_id && this.input.vendors_id.length) {
        let params = new URLSearchParams()
        this.input.vendors_id.forEach(element => {
          params.append('ids', element.text)
        })
        let result = await adminuserService.headVendorListExistAsync(params)
        if (result.status === 200) {
          this.isValidate.vendors_id = false
        } else if (
          (result.status && result.status === 404) ||
          (result.response.status && result.response.status === 404)
        ) {
          this.isValidate.vendors_id = true
          // this.input.vendors_id.splice(-1, 1);
        } else {
          if (result.response.data.message) {
            this.$utils.notification(
              'error',
              result.response.data.message,
              2000
            )
          } else {
            this.$utils.notification('error', 'Bad request: Unkonw error', 2000)
          }
        }
      }
    },
    async getGroupInviteCode() {
      const data = JSON.stringify({
        access_token: this.input.token,
      })
      let isInvite = true
      let params = new URLSearchParams()
      params.append('email', this.input.email)
      let resultCheckUser = await userService.headUserAsync(params)
      console.log('resultCheckUser', resultCheckUser.response.status)
      if (resultCheckUser.response.status === 404) {
        let resultUser = await userService.createUserOAuthAsync(data)
        if (resultUser.status !== 201) {
          isInvite = false
          this.$utils.notification(
            'error',
            resultUser.response.data.message,
            2000
          )
        }
      }

      if (isInvite) {
        let result = await groupService.getCodeByGroupInviteAsync(
          this.applicationId,
          this.invite_code
        )
        if (result.status === 200) {
          this.group_invite = result.data
          if (this.input.email !== this.group_invite.email) {
            this.$utils.notification(
              'error',
              'Email ที่ลงทะเบียนไว้ไม่ตรงกัน',
              2000
            )
          } else {
            console.log('next step')
            if (this.$refs.wizard) {
              this.$refs.wizard.nextTab()
            }
          }
        } else {
          this.$utils.notification('error', result.response.data, 2000)
        }
      }
    },
    async onCreateInviteGroupUserByCode() {
      let obj = this.group_invite_data
      console.log(obj)
      let data = {
        id: obj.open_id,
        reference_id: {
          psgv2_id:
            obj.employee_info.psgv2_id === undefined
              ? ''
              : obj.employee_info.psgv2_id,
          crc_id:
            obj.employee_info.crc_id === undefined
              ? ''
              : obj.employee_info.crc_id,
          ofm_id:
            obj.employee_info.ofm_id === undefined
              ? ''
              : obj.employee_info.ofm_id,
        },
        info: {
          first_name: {
            th: obj.name.th === undefined ? '' : obj.name.th,
            en: obj.name.en === undefined ? '' : obj.name.en,
          },
          last_name: {
            th: obj.last_name.th === undefined ? '' : obj.last_name.th,
            en: obj.last_name.en === undefined ? '' : obj.last_name.en,
          },
          email: obj.email,
        },
      }

      let result = await groupService.createGroupUserByCodeInviteAsync(
        this.applicationId,
        this.invite_code,
        data
      )
      if (result.status === 201) {
        // var item = result.data
        this.$utils.notification('success', 'Register Successed', 1500)
        this.onReset()
        this.$router.push({ path: '/login' })
      } else {
        this.$utils.notification('error', result, 2000)
      }
    },
  },
}
</script>
<style>
.ti-input[data-v-61d92e31] {
  border-radius: 0.25rem;
}
.readonly {
  background-color: grey;
}
</style>
